<div class="page-wrapper" [ngClass]="[theme === 'dark'? 'dark' : '']">
    <div class="content">
        <div class="order-details">
            <div class="content p-0">
                <div class="page-header">
                    <div class="page-title">
                        <h4>Work Log</h4>
                    </div>
                    <div class="page-btn d-flex">
                        <!-- <a class="btn btn-added ms-3" (click)="upload('/utility/upload',{ type: 'budget' })"> Upload Budget</a> -->
                        <button class="btn btn-added" (click)="AddWorklog('Add')">+Add</button>
                        <a class="btn btn-added" (click)="exportTable()">Export</a>
                        <!-- <app-common-bulk-print [columns]="columns"
                                [data]="selectedRows" [downloadPdf]="false" [print]="true"></app-common-bulk-print> -->
                        <div class="col" style="padding-left: 0;">
                            <!-- <div class="dropdown" aria-haspopup="true">
                                <button class="btn btn-added" aria-label="Dropdown Toggle" aria-haspopup="true" [disabled]="selectedRows.length === 0" style="width: 82px;">
                                Export &nbsp;<i class="pi pi-angle-down"></i>
                                </button>
                            
                                <div class="dropdown-content">
                                <ul>
                                    <li >
                                        <app-common-bulk-print [columns]="columns" [data]="selectedRows" [downloadPdf]="true" [print]="false"></app-common-bulk-print>
                                    </li>
                                    <li >
                                        <app-download-excel [data]="selectedRows" [columnsToExport]="columnsToExport"></app-download-excel>
                                    </li>
                                    <li >
                                        <app-common-csv [data]="selectedRows"></app-common-csv>
                                    </li>
                                </ul>
                                </div>
                            </div> -->
                        </div>                                
                    </div>
                </div>


                <div class="card">
                    <div class="card-body">
                        <div class="table-top">
                            <div class="search-set">
                                <app-filter [showProject]="true" [showWorklogStatus]="true" [showDateFilter]="true" [showEmployee]="true" (filterChange)="onFilterChange($event)"
                                    (resetFilters)="onResetFilters()">
                                </app-filter>
                                <a class="btn btn-primary ml-3 mr-3" *ngIf="role == 'SuperAdmin'" (click)="myWorklog()">
                                    <span *ngIf="showMyWorklog">
                                        Others Worklog
                                    </span> 
                                    <span *ngIf="!showMyWorklog">
                                        My Worklog
                                    </span>  
                                </a>
                                <!-- <a *ngIf="selectedData.length == 1" class="btn btn-primary ml-3 mr-3" (click)="duplicateEvent()">Duplicate</a>
                                <a *ngIf="selectedData.length > 0" class="btn btn-primary ml-3 mr-3" (click)="deleteEvent()">Delete</a> -->
                            </div>

                        </div>

                        <app-shared-table #sharedTable [columns]="columns" [data]="tableLists" [dropdownOptions]="dropdownOptions"
                            (sortChange)="onSortChange($event)" (selectedRowsDelete)="onSelectedRowsDelete($event)" (selectedRowsChange)="onSelectedRowsChange($event)">
                        </app-shared-table>


                    </div>
                    <app-pagination [totalCount]="totalCount" [pageSize]="pageSize" [currentPage]="currentPage"
                        (pageChange)="paginate($event)"></app-pagination>

                </div>
            </div>
        </div>
    </div>
</div>